import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../Button';
import { CloseIcon } from '../../Icons';
import { forwardRef } from 'react';
import { styled } from '../../system';
export const CloseButton = forwardRef(({ variant = 'neutralGhost', ...props }, ref) => (_jsx(StyledButton, { ...props, ref: ref, icon: _jsx(CloseIcon, {}), variant: variant, iconButton: true })));
const StyledButton = styled(Button, {
    flexCenter: true,
    variants: {
        size: {
            xs: {
                p: 0,
                minMaxSize: '24px !important',
                textXs: true
            },
            sm: {
                p: 0,
                minMaxSize: '36px !important',
                textSm: true
            },
            md: {
                p: 0,
                minMaxSize: '40px !important',
                textSm: true
            },
            lg: {
                p: 0,
                minMaxSize: '44px !important',
                textMd: true
            },
            xl: {
                p: 0,
                minMaxSize: '48px !important',
                textMd: true
            },
            '2xl': {
                p: 0,
                minMaxSize: '60px !important',
                textLg: true
            }
        },
        circle: {
            true: {
                rounded: '$full'
            }
        }
    }
});
CloseButton.displayName = 'CloseButton';
